import { render, staticRenderFns } from "./OptLangRadio.vue?vue&type=template&id=603dc640&scoped=true"
import script from "./OptLangRadio.vue?vue&type=script&lang=js"
export * from "./OptLangRadio.vue?vue&type=script&lang=js"
import style0 from "./OptLangRadio.vue?vue&type=style&index=0&id=603dc640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603dc640",
  null
  
)

export default component.exports